/** Join validation errors into one UI-friendly string. */
export function formatValidationErrors(result) {
    if (result.valid)
        return '';
    if (result.errors.length === 1)
        return result.errors[0];
    return ("".concat(result.errors.length, " validation errors:\n") +
        result.errors.map(function (e, i) { return "  ".concat(i + 1, ". ").concat(e); }).join('\n'));
}
